// store/deviceStore.js
import { create } from "zustand";

const useDeviceStore = create((set) => ({
  searchDevice: "",
  setSearchDevice: (value) => set({ searchDevice: value }),
  selectedDevice: null,
  setSelectedDevice: (value) => set({ selectedDevice: value }),
}));

export default useDeviceStore;
